import React, { useState, useEffect } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, TextField, Tooltip, CircularProgress, Checkbox, Box, Typography, Switch } from "@material-ui/core"
import { KeyboardDatePicker, MuiPickersUtilsProvider, } from "@material-ui/pickers"
import AttachmentIcon from '@material-ui/icons/Attachment';
import { DropzoneArea } from "material-ui-dropzone";
import CloseIcon from "@material-ui/icons/Close"
import MomentUtils from "@date-io/moment"
import InfoIcon from '@material-ui/icons/Info';
import GetAppIcon from '@material-ui/icons/GetApp';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { backendDateFormat, dayMonthDateFormat } from "../../../constants"
import moment from "moment";
import { useSnackbar } from 'notistack';
import { checkApiStatus, format_Commas } from "../../../utils";
import { globalPutService, globalPostService, globalGetService, globalFileUploadService, globalDeleteService } from '../../../utils/globalApiServices';
import { PageLoader, DeletePopUp } from '../../../shared_elements';
import { regexConstants } from '../../../constants/regEx';
import { specificKey, specificMessTsn, specificMessCsn } from '../../camo';
import { fleetSbData, StepperFile, AssessmentList } from '.';
import { trackActivity } from '../../../utils/mixpanel';
import { smbcInstance,acumenCamo } from '../../../shared_elements/components';
function AddEditFleetSB({ toggleModalFn, fleetData, modeType, getResponseBack }) {
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const [data, setData] = useState(fleetData ? fleetData : fleetSbData)
	const [error, setError] = useState({})
	const [isLoading, setLoading] = useState(false)
	const [applicability, setApplicability] = useState([])
	const [egineFamily, setEngineFamily] = useState([])
	const [uploadFile, setUploadFile] = useState(false)
	const [engineFamilyCache, setEngineFamilyCache] = useState({});
	const [removedEngineTypeIds, setRemovedEngineTypeIds] = useState(new Set());
	const [assessmentData, setAssessmentData] = useState({})
	const [assessmentFinalSave, setAsseementFinalSave] = useState({ modal: false })
	useEffect(() => {
		getEngineFamily()
		// if (data?.engine_family) {
		// 	onChangeEngineFamily('engine_family', data?.engine_family)
		// }
		// else{
		// 	getApplicability()
		// }
	}, [])
 console.log("isLoading",isLoading)

	const onFieldChange = (keyParam, value) => {
		if (keyParam === "sb_applicability") {
			const currentIds = new Set((data?.sb_applicability || []).map(i => i.id));
			const newIds = new Set(value.map(i => i.id));

			setRemovedEngineTypeIds(prev => {
				const updated = new Set(prev);

				// Add newly removed IDs
				currentIds.forEach(id => {
					if (!newIds.has(id)) updated.add(id);
				});
				// Remove re-added IDs
				newIds.forEach(id => {
					if (updated.has(id)) updated.delete(id);
				});

				return updated;
			});
			setData(prev => ({ ...prev, [keyParam]: value }));
		}
		else if (keyParam === "attachments") {
			if (Array.isArray(value)) {
				setData(prev => ({
					...prev,
					attachments: [...(prev.attachments || []), ...value]
				}));
			}
		} else if (keyParam === "esn_range") {
			setData(prev => ({ ...prev, [keyParam]: value, ['esn_list']: null, ['esnFrom']: null, ['esnTo']: null }));
		}
		else {
			setData(prev => ({ ...prev, [keyParam]: value }));
		}
	};

	const onChangeEngineFamily = async (keyParam, value) => {
		if (keyParam === 'engine_family' && (!value || value.length === 0)) {
			setData(prev => ({
				...prev,
				engine_family: [],
				sb_applicability: []
			}));
			setApplicability([]); // reset dropdown options
			setEngineFamilyCache({});
			setRemovedEngineTypeIds(new Set());
			return;
		}
		const prevFamilies = data?.engine_family || [];
		const addedFamilies = value?.filter(v => !prevFamilies.some(p => p.id === v.id));
		const removedFamilies = prevFamilies.filter(p => !value.some(v => v.id === p.id));

		// Handle partial deselection
		if (removedFamilies.length > 0) {
			const updatedCache = { ...engineFamilyCache };
			removedFamilies?.forEach(family => {
				delete updatedCache[family?.id];
			});

			const remainingEngineTypes = (data?.sb_applicability || []).filter(item =>
				value.some(family => updatedCache[family.id]?.some(engine => engine?.id === item?.id))
			);

			setRemovedEngineTypeIds(prev => {
				const newSet = new Set(prev);
				removedFamilies.forEach(family => {
					const familyEngineTypes = engineFamilyCache[family?.id] || [];
					familyEngineTypes.forEach(engineType => {
						newSet.delete(engineType?.id);
					});
				});
				return newSet;
			});

			setEngineFamilyCache(updatedCache);

			// Update BOTH selected and dropdown options
			const allAvailableEngineTypes = value?.flatMap(family => updatedCache[family?.id] || []);
			setApplicability(allAvailableEngineTypes);

			setData(prev => ({
				...prev,
				[keyParam]: value,
				sb_applicability: remainingEngineTypes
			}));
			return;
		}

		// Handle added families
		try {
			const updatedCache = { ...engineFamilyCache };
			const familiesToFetch = addedFamilies?.filter(family => !updatedCache[family?.id]);

			if (familiesToFetch?.length > 0) {
				const responses = await Promise.all(
					familiesToFetch?.map(family =>
						globalGetService(`camo/engine_dropdown/${family?.id}/`)
					)
				);

				responses.forEach((res, index) => {
					if (checkApiStatus(res)) {
						updatedCache[familiesToFetch[index]?.id] =
							res.data?.data?.engine_type || [];
					}
				});
			}

			setEngineFamilyCache(updatedCache);

			const allEngineTypes = value?.flatMap(family => updatedCache[family?.id] || []);
			const validEngineTypes = allEngineTypes?.filter(item => !removedEngineTypeIds?.has(item.id));

			const uniqueEngineTypes = [...new Map(validEngineTypes?.map(item => [item.id, item]))?.values()];

			const existingSelections = (data?.sb_applicability || []).filter(
				item => validEngineTypes.some(e => e.id === item.id)
			);
			const newSelections = uniqueEngineTypes.filter(
				item => !existingSelections?.some(e => e.id === item.id)
			);

			const newApplicability = [...existingSelections, ...newSelections];

			// Update dropdown options
			setApplicability(uniqueEngineTypes);

			setData(prev => ({
				...prev,
				[keyParam]: value,
				sb_applicability: newApplicability
			}));

		} catch (error) {
			console.error("Error fetching engine types:", error);
			setData(prev => ({ ...prev, [keyParam]: value }));
		}
	};

	const onRestErrorKey = (keyParam) => {
		setError({ [keyParam]: '' })
	}

	const getEngineFamily = () => {
		globalGetService(`camo/engine_dropdown/`)
			.then((response) => {
				if (checkApiStatus(response)) {
					setEngineFamily(response?.data?.data?.engine_family)
				}
			})
	}
	// const getApplicability = () => {
	// 	globalGetService(`console/engine-types/`)
	// 		.then((response) => {
	// 			if (response.status === 200) {
	// 				setApplicability(response?.data?.data?.engineTypes)
	// 			}
	// 		})
	// }
	const onAddNewAsset = (finalSave) => {
		let validationInputs = {}
		if (!smbcInstance) {
			validationInputs = {
				...validationInputs,
				ata_chapter: data?.ata_chapter ? '' : "Please Enter ATA Chapter",
				sb_ref_number:acumenCamo ? '': data?.sb_ref_number ? '' : "Please Enter SB Refrence Number",
				description: acumenCamo ? '':data?.description ? '' : "Please Enter Description",
				revision:(data?.sb_assessment  || acumenCamo) ? '': data?.revision ? '' : "Please Enter Revision",
				workorder:  (data?.sb_assessment ||acumenCamo) ? '':data?.sb_compliance_status === "NOT APPLICABLE" || data?.workorder ? '' : "Please Enter WorkOrder",
				revision_date: (data?.sb_assessment ||acumenCamo) ? '': data?.revision_date ? '' : "Please Enter Revision Date",
				sb_compliance_date:(data?.sb_assessment || acumenCamo) ? '':data?.sb_compliance_status === "COMPLIED" ? data?.sb_compliance_date ? '' : "Please Select SB Compliance Date" : '',
				sb_compliance_dfp:(data?.sb_assessment || acumenCamo ) ? '': data?.sb_compliance_dfp ? '' : "Please Select SB Compliance",

			}
		}
		if (smbcInstance) {
			validationInputs = {
				...validationInputs,
				sb_ref_number: data?.sb_ref_number ? '' : "Please Enter SB Refrence Number",
			}
		}
		if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
			setLoading(true)
			const { sb_interval_type, sb_interval, remaining, checklist, next_due_note, due_date, last_done_date, last_done_fh, last_done_fc, dimension_type, dimension_interval, dimension_interval_days, dimension_interval_fc, ...payload } = data || {};
			// let payload = Object.assign({}, data);
			if (data?.id) {
				delete payload?.sb_assessment_status
				finalSave === "finalSave" && delete payload?.sb_compliance_status
				globalPutService(`camo/fleet_sb/${payload.id}/`, {
					...payload,
					asset_type_id: 2,
					engine_family: payload?.engine_family ? payload?.engine_family : '',
					sb_applicability: payload?.sb_applicability?.map(item => item?.id).join(','),
					sb_compliance_tsn: payload.sb_compliance_tsn ? payload?.sb_compliance_tsn : null,
					sb_compliance_csn: payload.sb_compliance_csn ? payload?.sb_compliance_csn.toString().replace(",", "") : null,
					sb_assessment: payload?.sb_assessment || false,
					esn_range: payload?.esn_range || false,
					esn_list: payload?.sb_assessment ? payload?.esn_range ? `${data?.esnFrom} - ${data?.esnTo}` : payload?.esn_list : null,
					part_number_list: payload?.sb_assessment ? payload?.part_number_list : null,
					serial_number_list: payload?.sb_assessment ? payload?.serial_number_list : null,
					submit_btn_type:finalSave === "PROCESS" ? "PROCESS" : finalSave === "finalSave" ? "SAVE_CHANGES" : "SAVE" 
				})
					.then(response => {
						setLoading(false)
						if (checkApiStatus(response)) {
							if (finalSave === "finalSave") {
								getResponseBack()
							} else {
								enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
								toggleModalFn(); getResponseBack()
							}
							if (data?.attachments?.length) {
								importFile(response?.data?.data)
							}
							trackActivity('Fleet SB Data Updated Success - Airworthiness Management', {
								event_type: 'Fleet SB Updated Success',
								page_title: 'Fleet SB',
								updated_id: data?.id,
								success_msg: response?.data?.message
							})
						} else {
							if (finalSave === "finalSave") {
							} else {
								enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
							}
							trackActivity('Fleet SB Data Updated Failed - Airworthiness Management', {
								event_type: 'Fleet SB Updated Failed',
								page_title: 'Fleet SB',
								updated_id: data?.id,
								error_msg: response?.data?.message
							})
						}
					})
			} else {
				const esnList = payload?.esn_list?.trim();
				const partNumberList = payload?.part_number_list?.trim();
				const serialNumberList = payload?.serial_number_list?.trim();
				if (payload?.sb_assessment && !esnList && !partNumberList && !serialNumberList) {
					setLoading(false)
					enqueueSnackbar("Please Enter ESN, Part Number, or Serial Number.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
					return;
				}
				globalPostService(`camo/fleet_sb/`, {
					...payload,
					asset_type_id: 2,
					engine_family: payload?.engine_family ? payload?.engine_family : '',
					sb_applicability: payload?.sb_applicability?.map(item => item?.id).join(','),
					sb_compliance_tsn: payload.sb_compliance_tsn ? payload?.sb_compliance_tsn : null,
					sb_compliance_csn: payload.sb_compliance_csn ? payload?.sb_compliance_csn.toString().replace(",", "") : null,
					sb_assessment: payload?.sb_assessment || false,
					esn_range: payload?.esn_range || false,
					esn_list: payload?.sb_assessment ? payload?.esn_range ? `${data?.esnFrom} - ${data?.esnTo}` : payload?.esn_list : null,
					part_number_list: payload?.sb_assessment ? payload?.part_number_list : null,
					serial_number_list: payload?.sb_assessment ? payload?.serial_number_list : null,
					submit_btn_type:finalSave === "PROCESS" ? "PROCESS" : finalSave === "finalSave" ? "SAVE_CHANGES" : "SAVE" 
				})
					.then(response => {
						setLoading(false)
						if (checkApiStatus(response)) {
							enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
							toggleModalFn(); getResponseBack()
							if (data?.attachments?.length) {
								importFile(response?.data?.data)
							}
							trackActivity('Fleet SB Data Updated Success - Airworthiness Management', {
								event_type: 'Fleet SB Data Updated Success',
								page_title: 'Fleet SB Data',
								updated_id: data?.id,
								success_msg: response?.data?.message
							})
						} else {
							enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
							trackActivity('Fleet SB  Data Updated Failed - Airworthiness Management', {
								event_type: 'Fleet SB  Updated Failed',
								page_title: 'Fleet SB',
								updated_id: data?.id,
								error_msg: response?.data?.message
							})
						}
					})

			}
		} else {
			setError(validationInputs)
		}
	}
	const importFile = (item) => {
		let attach = data?.attachments || []
		var formData = new FormData();
		Object.keys(attach?.length && attach.filter(item => item instanceof File)).map((key) => {
			formData.append("[" + key + "]file", attach.filter(item => item instanceof File)[key])
			formData.append("[" + key + "]file_type", attach.filter(item => item instanceof File)[key].type)
			formData.append("[" + key + "]file_name", attach.filter(item => item instanceof File)[key].name)
			formData.append("[" + key + "]module_id", item?.id)
			formData.append("[" + key + "]module_type_id", 15)
			formData.append("[" + key + "]asset_type_id", 2)
		})
		setLoading(true);
		globalFileUploadService(`camo/attachment/upload/?fleet=sb`, formData)
			.then(response => {
				if (checkApiStatus(response)) {
					toggleModalFn(); getResponseBack()
					trackActivity('Fleet SB Attachment Added Success - Airworthiness Management', {
						event_type: 'Fleet SB  Attachment Success',
						page_title: 'Fleet SB Import',
						success_msg: response?.data?.message
					})
					// enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
				} else {
					enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
					trackActivity('Fleet SB  Data Attachment Failed - Airworthiness Management', {
						event_type: 'Fleet SB  Attachment Failed',
						page_title: 'Fleet SB',
						error_msg: response?.data?.message
					})
				}
			})

	}
	const onRemoveUploadFile = (files) => {
		if (!files?.id) {
			setData({ ...data, attachments: data?.attachments.filter(item => item.name !== files.name) });
		} else {
			globalDeleteService(`camo/attachment/${files?.id}/delete/?fleet=sb`)
				.then((response) => {
					if (checkApiStatus(response)) {
						setData({ ...data, attachments: data?.attachments.filter(item => item.name !== files.name) })
						getResponseBack()
						enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					} else {
						enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });

					}
				})
		}
	}
	const [esnFrom, esnTo] = data?.esn_list ? data.esn_list.split("-") : ["", ""];

	const onChangeAssessment = (keyParam, value, index) => {
		setAssessmentData((prev) => {
			if (keyParam === "reduced_limit") {
				return {
					...prev,
					result: prev?.result?.map((item, i) => i === index ? { ...item, ["reduced_limit"]: value ? parseInt(value) : value } : item)
				};
			} else {
				return {
					...prev,
					result: prev?.result?.map((item, i) => i === index ? { ...item, [keyParam]: value } : item)
				};
			}

		});
	};

	const onSaveChanges = () => {
		setLoading(true)
		const payloadArray = Object.values(assessmentData?.result || {});
		let mainpayload = Object.assign({}, data)
		delete mainpayload?.id
		globalPostService(`camo/fleet_sb_assessment/bulk/${data?.id}/`, { assessment_data: payloadArray, sb_status_data: mainpayload })
			.then(response => {
				setLoading(false)
				if (checkApiStatus(response)) {
					setTimeout(() => {
						onAddNewAsset("finalSave")
					}, 300)
					toggleModalFn(); getResponseBack()
					enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
				} else {
					enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
				}
			})
	}
	const activeActiveApplicabilty = (esnList) => {
		globalGetService(`camo/assets_as_per_applicability/?applicability=${data?.sb_applicability?.map(item => item?.id).join(',')}&esn_list=${esnList}`)
			.then(response => {
				if (checkApiStatus(response)) {
				} else {
					if (response?.data?.data?.length) {
						enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					}
				}
			})
	}

	return (
		<>
			<Dialog
				open={true}
				onClose={toggleModalFn}
			>
				<DialogTitle> {modeType === "edit" ? "Edit Fleet SB" : "Add Fleet SB"} </DialogTitle>
				<DialogContent dividers>
					{data?.id && !data?.sb_assessment ? null : <><Checkbox
						name={data?.sb_assessment}
						color="primary"
						size="small"
						onChange={(e) => onFieldChange("sb_assessment", e.target.checked)}
						checked={data?.sb_assessment}
						disabled={data?.assessment_job_id}
					/> SB Assessment</>}
					<Grid spacing={1} container>
						<Grid item xs={12} md={3} sm={3}>
							<TextField
								required={!smbcInstance}
								variant="outlined"
								margin='normal'
								label="ATA Chapter"
								id="ata_chapter"
								fullWidth
								inputProps={{ maxLength: 200 }}
								value={data?.ata_chapter}
								InputLabelProps={{ shrink: true }}
								error={error.ata_chapter ? true : false}
								helperText={error.ata_chapter ? error.ata_chapter : ""}
								onChange={(e) => { onFieldChange("ata_chapter", e.target.value); onRestErrorKey("ata_chapter") }}
								disabled={data?.sb_assessment_status === "COMPLETED"}
							/>
						</Grid>
						<Grid item xs={12} md={3} sm={3}>
							<TextField
								variant="outlined"
								margin='normal'
								label="SB Reference Number"
								id="sb_ref_number"
								required={acumenCamo ? false :true}
								fullWidth
								value={data?.sb_ref_number}
								InputLabelProps={{ shrink: true }}
								inputProps={{ maxLength: 200 }}
								error={error.sb_ref_number ? true : false}
								helperText={error.sb_ref_number ? error.sb_ref_number : ""}
								onChange={(e) => { onFieldChange("sb_ref_number", e.target.value); onRestErrorKey("sb_ref_number") }}
								disabled={data?.sb_assessment_status === "COMPLETED"}
							/>
						</Grid>
						<Grid item xs={12} md={6} sm={6}>
							<TextField
								variant="outlined"
								label="SB Issued by"
								margin='normal'
								id="sb_issued_by"
								fullWidth
								inputProps={{ maxLength: 200 }}
								InputLabelProps={{ shrink: true }}
								value={data?.sb_issued_by}
								onChange={(e) => onFieldChange("sb_issued_by", e.target.value)}
								disabled={data?.sb_assessment_status === "COMPLETED"}
							/>
						</Grid>
						<Grid spacing={1} container>
							<Grid item xs={12} md={3} sm={3}>
								<Autocomplete
									id="engine_family"
									options={egineFamily || []}
									getOptionLabel={(option) => option?.name}
									value={data?.engine_family || []}
									margin='normal'
									multiple={true}
									disabled={data?.assessment_job_id || modeType === "edit" && fleetData?.engine_family?.length}
									onChange={(e, value) => onChangeEngineFamily("engine_family", value)}
									renderInput={(params) => (
										<TextField
											{...params}
											label={
												<span style={{ verticalAlign: 'super' }}>
													Engine Family
													<Tooltip placement='right' title="Select Engine Family to apply all Engine Types under the family to Applicability" arrow>
														<InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
													</Tooltip>
												</span>
											}
											margin='normal'
											placeholder="Select Engine Family"
											variant="outlined"
											fullWidth
											InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12} md={9} sm={9}>
								<Autocomplete
									id="ad_type"
									options={applicability || []}
									getOptionLabel={(option) => option?.name}
									value={data?.sb_applicability || []}
									margin='normal'
									multiple={true}
									disabled={data?.assessment_job_id || modeType === "edit" && fleetData?.sb_applicability?.length}
									disableCloseOnSelect={true}
									onChange={(e, value) => onFieldChange("sb_applicability", value)}
									renderInput={(params) => (
										<TextField
											{...params}
											label="SB Applicability"
											margin='normal'
											placeholder="Select Applicability"
											variant="outlined"
											fullWidth
											InputLabelProps={{ shrink: true }}
										/>
									)}
								/>
							</Grid>
						</Grid>
					</Grid>
					<Grid spacing={1} container>
						<Grid item xs={12}>
							<TextField
								required={acumenCamo ? false :!smbcInstance }
								variant="outlined"
								label="SB Description"
								margin='normal'
								id="description"
								multiline
								fullWidth
								InputLabelProps={{ shrink: true }}
								value={data?.description}
								onChange={(e) => { onFieldChange("description", e.target.value); onRestErrorKey("description") }}
								error={error.description ? true : false}
								helperText={error.description ? error.description : ""}
								disabled={data?.sb_assessment_status === "COMPLETED"}
							/>
						</Grid>
					</Grid>
					<Grid spacing={1} container>
						<Grid item xs={12} md={3} sm={3}>
							<Autocomplete
								id="type"
								options={['ALERT', 'STANDARD', 'OPTIONAL']}
								getOptionLabel={option => option}
								margin='normal'
								fullWidth
								value={data?.type || null}
								disabled={data?.sb_assessment_status === "COMPLETED"}
								onChange={(e, value) => onFieldChange("type", value)}
								renderInput={(params) => (
									<TextField
										{...params}
										label="SB Type"
										placeholder="Select SB Type"
										variant="outlined"
										fullWidth
										margin='normal'
										InputLabelProps={{ shrink: true }}
									/>
								)}
							/>
						</Grid>
						<Grid item xs={12} md={3} sm={3}>
							<TextField
								variant="outlined"
								label="SB Effectivity"
								margin='normal'
								id="effectivity"
								fullWidth
								inputProps={{ maxLength: 550 }}
								InputLabelProps={{ shrink: true }}
								value={data?.effectivity}
								disabled={data?.sb_assessment_status === "COMPLETED"}
								onChange={(e) => onFieldChange("effectivity", e.target.value)}
							/>
						</Grid>
						<Grid item xs={12} md={3} sm={3}>
							<MuiPickersUtilsProvider utils={MomentUtils}>
								<KeyboardDatePicker
									id="effectivity_date"
									label="SB Effective Date"
									margin='normal'
									format={dayMonthDateFormat}
									inputVariant="outlined"
									fullWidth
									disableFuture
									InputLabelProps={{ shrink: true }}
									minDate={moment().subtract(25, "years")}
									value={data?.effectivity_date || null}
									error={false}
									helperText={""}
									disabled={data?.sb_assessment_status === "COMPLETED"}
									onPaste={(event) => event.preventDefault()}
									onChange={(data) => onFieldChange("effectivity_date", moment(data).isValid() ? moment(data).format(backendDateFormat) : null)}
								/>
							</MuiPickersUtilsProvider>
						</Grid>
						{data?.sb_assessment ? null : <Grid item xs={12} md={3} sm={3}>
							<Autocomplete
								id="sb_compliance_status"
								options={['OPEN', 'COMPLIED', 'FACTORY COMPLIED', 'PARTIALLY COMPLIED', 'INFORMATION ONLY', 'CANCELLED', 'NOT APPLICABLE', 'REPEAT INSPECTION']}
								getOptionLabel={option => option}
								margin='normal'
								fullWidth
								value={data?.sb_compliance_status || null}
								disabled={data?.sb_assessment_status === "COMPLETED"}
								onChange={(e, value) => onFieldChange("sb_compliance_status", value)}
								renderInput={(params) => (
									<TextField
										{...params}
										label="Compliance Status"
										placeholder="Select Compliance Status"
										variant="outlined"
										fullWidth
										margin='normal'
										InputLabelProps={{ shrink: true }}
									/>
								)}
							/>
						</Grid>}
					</Grid>
					{data?.sb_assessment ? null : <Grid spacing={1} container>
						<Grid item xs={12} md={3} sm={3}>
							<TextField
								variant="outlined"
								label={
									<span style={{ verticalAlign: 'super' }}>
										SB Compliance TSN
										<Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999</span>} arrow>
											<InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
										</Tooltip>
									</span>
								}
								margin='normal'
								id="sb_compliance_tsn"
								inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data?.sb_compliance_tsn) && 10 }}
								InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
								fullWidth
								value={regexConstants.alphanumespcespclchar.test(data?.sb_compliance_tsn) ? data?.sb_compliance_tsn : format_Commas(data?.sb_compliance_tsn.replace(/[^0-9.]/g, ''))}
								// value={data?.sb_compliance_tsn ? format_Commas(data?.sb_compliance_tsn.replace(/[^0-9.]/g, '')) : ''}
								disabled={data?.sb_compliance_status === "NOT APPLICABLE" || data?.sb_assessment_status === "COMPLETED"}
								error={error.sb_compliance_tsn ? true : false}
								helperText={error?.sb_compliance_tsn ? error?.sb_compliance_tsn : ""}
								onChange={(e) => {
									const value = format_Commas(e.target.value).replace(/[^0-9.]/g, '');
									const numericValue = value.replace(/[^\d.]/g, '');
									const dotCount = (numericValue.match(/\./g) || []).length;
									const isValid = dotCount ? (numericValue.replace(".", "").length - dotCount <= 6 && regexConstants.numberWithDot.test(numericValue)) : value.length <= 5 && regexConstants.numberWithDot.test(numericValue);
									if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
										onFieldChange("sb_compliance_tsn", e.target.value);
										setError({ ...error, sb_compliance_tsn: e.target.value === (null || undefined || "") ? "" : !specificKey.includes(e.target.value.toUpperCase()) && specificMessTsn })
									} else if (isValid || value === "") {
										onFieldChange("sb_compliance_tsn", numericValue);
										setError({ ...error, sb_compliance_tsn: regexConstants.numberWithDot.test(numericValue) || e.target.value === (null || undefined || "") ? "" : e.target.value === null ? "" : "" })

									}
								}}
							/>
						</Grid>
						<Grid item xs={12} md={3} sm={3}>
							<TextField
								variant="outlined"
								label={
									<span style={{ verticalAlign: 'super' }}>
										SB Compliance CSN
										<Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999</span>} arrow>
											<InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
										</Tooltip>
									</span>
								}
								margin='normal'
								id="sb_compliance_csn"
								fullWidth
								inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data?.sb_compliance_csn) ? 8 : 6 }}
								InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
								disabled={data?.sb_compliance_status === "NOT APPLICABLE" || data?.sb_assessment_status === "COMPLETED"}
								error={error.sb_compliance_csn ? true : false}
								helperText={error.sb_compliance_csn ? error.sb_compliance_csn : ""}
								value={regexConstants.alphanumespcespclchar.test(data?.sb_compliance_csn) ? data.sb_compliance_csn : format_Commas(data?.sb_compliance_csn.toString().replace(/[^0-9.]/g, ''))}
								onChange={(e) => {
									if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
										onFieldChange("sb_compliance_csn", e.target.value);
										setError({ ...error, sb_compliance_csn: e.target?.value === null || e.target?.value === "" ? "" : !specificKey.includes(e.target.value.toUpperCase()) && specificMessCsn })

									} else {
										e.target.value.length <= 6 && (regexConstants.onlyNumeric.test(format_Commas(e.target.value).replace(/[^0-9.]/g, '')) || e.target.value === "") && onFieldChange('sb_compliance_csn', e.target.value)
										setError({ ...error, sb_compliance_csn: e.target?.value === null || regexConstants.numberWithComma.test(e.target.value) || e.target?.value === "" ? "" : "" })

									}
								}
								}
							/>
						</Grid>
						<Grid item xs={12} md={3} sm={3}>
							<MuiPickersUtilsProvider utils={MomentUtils}>
								<KeyboardDatePicker
									required={smbcInstance ? false : acumenCamo ? false : data?.sb_compliance_status === "COMPLIED"}
									id="sb_compliance_date"
									label="SB Compliance Date"
									format={dayMonthDateFormat}
									inputVariant="outlined"
									fullWidth
									disableFuture
									margin='normal'
									onPaste={(event) => event.preventDefault()}
									InputLabelProps={{ shrink: true }}
									minDate={moment().subtract(25, "years")}
									value={data?.sb_compliance_date || null}
									disabled={data?.sb_assessment_status === "COMPLETED"}
									error={data?.sb_compliance_status === "COMPLIED" && error.sb_compliance_date ? true : false}
									helperText={data?.sb_compliance_status === "COMPLIED" && error.sb_compliance_date ? error.sb_compliance_date : ""}
									onChange={(data) => { onFieldChange("sb_compliance_date", moment(data).isValid() ? moment(data).format(backendDateFormat) : null); onRestErrorKey("sb_compliance_date") }}
								/>
							</MuiPickersUtilsProvider>
						</Grid>
						{/* {smbcInstance ?  */}
						<Grid item xs={12} md={3} sm={3}>
							<TextField
								variant="outlined"
								label="Category"
								value={data?.sb_category}
								inputProps={{ maxLength: 100 }}
								margin="normal"
								fullWidth
								InputLabelProps={{ shrink: true }}
								disabled={data?.sb_assessment_status === "COMPLETED"}
								onChange={(e) => onFieldChange("sb_category", e.target.value)}
							/>
						</Grid>
						{/* // :
						// 	<Grid item xs={12} md={3} sm={3}>
						// 		<TextField
						// 			variant="outlined"
						// 			label={<> Service Bulletin <span style={{ color: "red" }}> *</span> </>}
						// 			id="service_bulletin"
						// 			margin="normal"
						// 			fullWidth
						// 			InputLabelProps={{ shrink: true }}
						// 			value={data?.service_bulletin}
						// 			error={error.service_bulletin ? true : false}
						// 			helperText={error.service_bulletin ? error.service_bulletin : ""}
						// 			onChange={(e) => onFieldChange("service_bulletin", e.target.value)}
						// 		/>
						// 	</Grid>
						// } */}
					</Grid>}
					{data?.sb_assessment ? null : <Grid spacing={1} container>
						{/* {smbcInstance &&  */}
						<Grid item xs={12} md={4} sm={4}>
							<TextField
								variant="outlined"
								label="SB Impact"
								id="sb_impact"
								margin="normal"
								fullWidth
								inputProps={{ maxLength: 250 }}
								InputLabelProps={{ shrink: true }}
								required={acumenCamo ? false :!smbcInstance }
								value={data?.sb_impact}
								disabled={data?.sb_assessment_status === "COMPLETED"}
								onChange={(e) => onFieldChange("sb_impact", e.target.value)}
							/>
						</Grid>
						{/* } */}
						<Grid item xs={12} md={4} sm={4}>
							<TextField
								variant="outlined"
								label="Revision"
								id="revision"
								margin="normal"
								fullWidth
								inputProps={{ maxLength: 200 }}
								InputLabelProps={{ shrink: true }}
								required={acumenCamo ? false :!smbcInstance }
								value={data?.revision}
								error={error.revision ? true : false}
								helperText={error.revision ? error.revision : ""}
								disabled={data?.sb_assessment_status === "COMPLETED"}
								onChange={(e) => { onFieldChange("revision", e.target.value); onRestErrorKey("revision") }}
							/>
						</Grid>
						<Grid item xs={12} md={4} sm={4}>
							<MuiPickersUtilsProvider utils={MomentUtils}>
								<KeyboardDatePicker
									id="revision_date"
									required={acumenCamo ? false :!smbcInstance }
									label="Revision Date"
									format={dayMonthDateFormat}
									inputVariant="outlined"
									margin="normal"
									fullWidth
									disableFuture
									onPaste={(event) => event.preventDefault()}
									InputLabelProps={{ shrink: true }}
									minDate={moment().subtract(25, "years")}
									value={data?.revision_date || null}
									error={error.revision_date ? true : false}
									helperText={error.revision_date ? error.revision_date : ""}
									disabled={data?.sb_assessment_status === "COMPLETED"}
									onChange={(data) => { onFieldChange("revision_date", moment(data).isValid() ? moment(data).format(backendDateFormat) : null); onRestErrorKey("revision_date") }}
								/>
							</MuiPickersUtilsProvider>
						</Grid>
						<Grid item xs={12} md={4} sm={4}>
							<TextField
								variant="outlined"
								label="AD"
								margin='normal'
								id="ad_no"
								fullWidth
								value={data?.ad_no}
								inputProps={{ maxLength: 200 }}
								InputLabelProps={{ shrink: true }}
								disabled={data?.sb_assessment_status === "COMPLETED"}
								onChange={(e) => onFieldChange("ad_no", e.target.value)}
							/>
						</Grid>
						<Grid item xs={12} md={4} sm={4}>
							<TextField
								required={acumenCamo ? false :!smbcInstance }
								variant="outlined"
								label="Work Order"
								id="workorder"
								margin='normal'
								fullWidth
								inputProps={{ maxLength: 500 }}
								InputLabelProps={{ shrink: true }}
								value={data?.workorder}
								onChange={(e) => { onFieldChange("workorder", e.target.value); onRestErrorKey("workorder") }}
								error={error.workorder ? true : false}
								disabled={data?.sb_assessment_status === "COMPLETED"}
								helperText={error.workorder ? error.workorder : ""}
							/>
						</Grid>
						<Grid item xs={12} md={4} sm={4}>
							<TextField
								variant="outlined"
								label="Subject"
								id="subject"
								margin='normal'
								inputProps={{ maxLength: 200 }}
								fullWidth
								InputLabelProps={{ shrink: true }}
								value={data?.subject}
								disabled={data?.sb_assessment_status === "COMPLETED"}
								onChange={(e) => onFieldChange("subject", e.target.value)}
							/>
						</Grid>
						<Grid item xs={12} md={4} sm={4}>
							<FormControl required={acumenCamo ? false :!smbcInstance } margin='normal' error={error.sb_compliance_dfp ? true : false} helperText={error.sb_compliance_dfp ? error.sb_compliance_dfp : ""} >
								<FormLabel component="legend">SB Compliance DFP</FormLabel>
								<RadioGroup
									row
									aria-label="sb_compliance_dfp"
									name="sb_compliance_dfp"
									defaultValue="top"
									value={data?.sb_compliance_dfp}
									onChange={(e) => { onFieldChange("sb_compliance_dfp", e.target.value); onRestErrorKey("sb_compliance_dfp") }}
								>
									<FormControlLabel
										value="yes"
										control={<Radio size="small" color="primary" />}
										label="Yes"
									/>
									<FormControlLabel
										value="no"
										control={<Radio size="small" color="primary" />}
										label="No"
									/>
								</RadioGroup>
								{error.sb_compliance_dfp && (
									<span style={{ color: "red", fontSize: '0.75rem' }}>
										{error.sb_compliance_dfp}
									</span>
								)}
							</FormControl>
						</Grid>
						<Grid item xs={12} md={4} sm={4}>
							<FormControl margin='normal'>
								<FormLabel component="legend">Release Certificate</FormLabel>
								<RadioGroup
									row
									aria-label="release_certificate"
									name="release_certificate"
									defaultValue="top"
									value={data?.release_certificate}
									onChange={(e, value) => onFieldChange("release_certificate", e.target.value)}
								>
									<FormControlLabel
										value="yes"
										control={<Radio size="small" color="primary" />}
										label="Yes"
									/>
									<FormControlLabel
										value="no"
										control={<Radio size="small" color="primary" />}
										label="No"
									/>
								</RadioGroup>
							</FormControl>
						</Grid>
						<Grid item xs={12} md={4} sm={4}>
							<FormControl margin='normal'>
								<FormLabel component="legend"> Certificate of Conformity</FormLabel>
								<RadioGroup
									row
									aria-label="certificate_of_conformity"
									name="certificate_of_conformity"
									defaultValue="top"
									value={data?.certificate_of_conformity}
									onChange={(e, value) => onFieldChange("certificate_of_conformity", e.target.value)}
								>
									<FormControlLabel
										value="yes"
										control={<Radio size="small" color="primary" />}
										label="Yes"
									/>
									<FormControlLabel
										value="no"
										control={<Radio size="small" color="primary" />}
										label="No"
									/>
									<FormControlLabel
										value="N/A"
										control={<Radio size="small" color="primary" />}
										label="N/A"
									/>
								</RadioGroup>
							</FormControl>
						</Grid>
					</Grid>}

					<Grid container spacing={1} style={{ backgroundColor: data?.sb_assessment ? '#e5e5e5' : '', padding: data?.sb_assessment ? '10px' : '' }}>
						{data?.sb_assessment ? <>
							<Grid item xs={12} md={1} sm={1} style={{ alignContent: "center" }}>
								<Tooltip title={data?.esn_range ? "Click to enter ESN" : "Click to enter ESN Range"}>
									<Switch
										checked={data?.esn_range}
										onChange={(e) => onFieldChange("esn_range", e.target.checked)}
										name="esn_range"
										margin='normal'
										fullWidth
										disabled={data?.id}
										color='primary'
										inputProps={{ 'aria-label': 'primary checkbox' }}
									/>
								</Tooltip>
							</Grid>
							<Grid item xs={12} md={3} sm={3}>
								{data?.esn_range ?
									<Box display="flex" alignItems="center" gap={1}>
										<TextField
											variant="outlined"
											label="ESN From"
											fullWidth
											margin='normal'
											disabled={data?.id}
											InputLabelProps={{ shrink: true }}
											value={esnFrom ? esnFrom : data?.esnFrom || ""}
											onChange={(e) => onFieldChange("esnFrom", e.target.value)}
										/>
										<Typography variant="h6" style={{ marginInline: '10px' }}>-</Typography>
										<TextField
											variant="outlined"
											label="ESN To"
											fullWidth
											margin='normal'
											disabled={data?.id}
											InputLabelProps={{ shrink: true }}
											value={esnTo ? esnTo : data?.esnTo || ""}
											onChange={(e) => onFieldChange("esnTo", e.target.value)}
										/>
									</Box>
									:
									<TextField
										variant="outlined"
										label="ESN"
										id="esn_list"
										margin='normal'
										multiline
										fullWidth
										disabled={data?.id}
										// inputProps={{ maxLength: 500 }}
										InputLabelProps={{ shrink: true }}
										error={error?.esn_list ? true : false}
										helperText={error?.esn_list ? error?.esn_list : ""}
										value={data?.esn_list || ''}
										onChange={(e) => { onFieldChange("esn_list", e.target.value); onRestErrorKey("esn_list") }}
										onBlur={(e) => data?.sb_applicability && data?.esn_list ? activeActiveApplicabilty(e.target.value) : e.preventDefault()}
									/>
								}
							</Grid>
							<Grid item xs={12} md={4} sm={4}>
								<TextField
									variant="outlined"
									label="Part Number"
									id="part_number_list"
									margin='normal'
									multiline
									fullWidth
									disabled={data?.id}
									InputLabelProps={{ shrink: true }}
									error={error?.part_number_list ? true : false}
									helperText={error?.part_number_list ? error?.part_number_list : ""}
									value={data?.part_number_list}
									onChange={(e) => { onFieldChange("part_number_list", e.target.value); onRestErrorKey("part_number_list") }}
								/>
							</Grid>
							<Grid item xs={12} md={4} sm={4}>
								<TextField
									variant="outlined"
									label="Serial Number"
									id="serial_number_list"
									margin='normal'
									multiline
									fullWidth
									disabled={data?.id}
									InputLabelProps={{ shrink: true }}
									error={error?.serial_number_list ? true : false}
									helperText={error?.serial_number_list ? error?.serial_number_list : ""}
									value={data?.serial_number_list}
									onChange={(e) => { onFieldChange("serial_number_list", e.target.value); onRestErrorKey("serial_number_list") }}
								/>
							</Grid></> : null}
						<Grid item xs={12} md={6} sm={6}>
							<TextField
								label="Remarks"
								margin='normal'
								variant='outlined'
								fullWidth
								disabled={data?.sb_assessment_status === "COMPLETED"}
								InputLabelProps={{ shrink: true }}
								value={data?.remark || ''}
								onChange={(e) => onFieldChange("remark", e.target.value)}
								rows={3}
								multiline
							/>
						</Grid>
						<Grid item xs={12} md={6} sm={6} margin='normal' style={{ marginTop: "15px" }}>
							<div style={{ border: "1px solid #cfc1c1", textAlign: 'center', padding: "35px", borderRadius: "3px" }}>
								<span onClick={(e) => data?.assessment_job_id ? e.preventDefault() : setUploadFile(true)} style={{ cursor: data?.assessment_job_id ? 'not-allowed' : 'pointer' }}><AttachmentIcon color='primary' fontSize='small' style={{ verticalAlign: 'middle', display: data?.assessment_job_id ? 'none' : '' }} /> {data?.assessment_job_id ? "Uploaded File" : "Upload File"}</span>
								<div style={{ overflow: "auto" }}>
									{data?.attachments?.length > 0 && data?.attachments?.map((attachments) =>
										<>{attachments.name}
											<a href={decodeURIComponent(attachments.file)} download={attachments.file_name}><GetAppIcon color="primary" style={{ fontSize: 'medium', verticalAlign: 'middle' }} /></a>
											<CloseIcon onClick={() => onRemoveUploadFile(attachments)} color='secondary' style={{ fontSize: 'medium', verticalAlign: 'middle', display: data?.assessment_job_id ? 'none' : '' }} />
										</>
									)}
								</div>
							</div>
						</Grid>
					</Grid>
					<Grid container spacing={1}>
						<Grid item xs={12} md={12} sm={12}>
							{data?.assessment_job_id ? <StepperFile assessmentData={assessmentData} /> : null}
						</Grid>
						<Grid item xs={12} md={12} sm={12}>
							{data?.assessment_job_id ?
								<AssessmentList
									mainData={data}
									assessmentData={assessmentData}
									setAssessmentData={setAssessmentData}
									onChangeAssessment={onChangeAssessment}
									moduleName='sb'
								/> : null}
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions>
					<Button variant='outlined' color='primary' size='small' onClick={toggleModalFn}>CLOSE</Button>
					{data?.assessment_job_id ? <>
						{data?.sb_assessment_status === "COMPLETED" ? null :
							<Button variant='contained' disabled={assessmentData?.status !== "COMPLETED"} color='primary' size='small' onClick={() => setAsseementFinalSave({ modal: true })}>SAVE CHANGES</Button>} </> :
						data?.sb_assessment ? <Button variant='contained' color='primary' onClick={()=>onAddNewAsset("PROCESS")}>PROCESS</Button>
							:
							<Button variant='contained' color='primary' size='small' onClick={()=>onAddNewAsset("SAVE")}>SAVE</Button>
					}
				</DialogActions>
			</Dialog>
			{
				assessmentFinalSave?.modal ?
					<DeletePopUp
						title='Save SB Assessment'
						deleteRecordFn={() => onSaveChanges()}
						modal={() => setAsseementFinalSave({ modal: true })}
						content='Once you save assessment you are not able to edit assessment again,are you sure ?'
						toggleModalFn={() => setAsseementFinalSave({ modal: false })}
						confirmText="SAVE"
						confirmColor="primary"
					/> : null
			}
			{
				uploadFile ?
					<Dialog
						open={true}
						onClose={() => setUploadFile(false)}
						className='camo-management-modal'
						maxWidth={'md'}
					>
						<DialogTitle id="scroll-dialog-title">
							Upload SB  File
						</DialogTitle>
						<DialogContent dividers={true}>
							<div style={{ width: '380px' }}>
								<DropzoneArea
									filesLimit={5}
									maxFileSize={104857600}
									showPreviewsInDropzone={false}
									useChipsForPreview={true}
									showPreviews={true}
									dropzoneText={<p>Drag & Drop file Or Click Here </p>}
									dropzoneClass="drag-drop-cnt"
									maxWidth="sm"
									showAlerts={['info', 'error']}
									alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
									clearOnUnmount={true}
									onChange={(value) => onFieldChange("attachments", value)}
								/>
							</div>
						</DialogContent>
						<DialogActions>
							<Button disabled={isLoading} onClick={() => setUploadFile(false)} color='primary' size='small' variant='outlined'>CLOSE</Button>
							<Button onClick={() => setUploadFile(false)} color='primary' size='small' variant='contained'>
								{isLoading ? <CircularProgress size={24} color='white' /> : 'SAVE'}
							</Button>
						</DialogActions>
					</Dialog>
					: null

			}
			{isLoading ? <PageLoader /> : null}

		</>
	)
}
export default AddEditFleetSB;
